import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La arbo brakumis per siaj branĉoj lanternon.
    </p>
    
    <p class="mb-3">
      Ĝi kreskis apude, kaj estis tiel soleca! Alta kaj svelta, kun unusola bela floro supre, hele brilanta nokte, -- sed tute senbranĉa. Eble, troviĝis neniu por zorgi pri li, kaj li senespere faligis la brakojn… Kaj nure la floro supre disŝiris mallumon en muta alvoko: venu iu, rememoru, atentu min!
    </p>
    
    <p class="mb-3">
      La arbo karesis lin per siaj folioj, superŝutis per semoj. Espereble, li respondos; espereble, naskiĝos ĉe li novaj floroj, multaj novaj floroj…
    </p>
    
    <p class="mb-3">
      Tiel staris apude vivanta arbo kaj senviva fera lanterno.
    </p>
    `
  )
}

const itemName = {
  esp: 'Amo en urbo'
}

const itemDate = {
  esp: `26 julio 2023`
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;